import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Switch from "../../components/Switch";
import useApiUrls from "../../useApiUrls";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import Pagination from "../../components/Pagination";

const DqrImagesList = () => {
  const [data, setData] = useState([]);
  const [campaignId, setCampaignId] = useState([]);
  const [dataLimit, setDataLimit] = useState(100);
  const [count, setCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [isOn, setIsOn] = useState(false);
  const[copied,setCopied] = useState(false);
  
    const [publishLoading, setPublishLoading] = useState(false);

  // Declare state variables
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [activeStatus, setActiveStatus] = useState("");
  const [message, setMessage] = useState("");
  const { getUrlByOperation, error: urlError } = useApiUrls();
  
  const [publishInfo, setPublishInfo] = useState({});
  const [copySuccess, setCopySuccess] = useState(false);

  const navigate = useNavigate();

  const token = getCookie("token");
  const userid = getCookie("userid");

  const requestBody = {
    id: 0,
    applycreateddate: false,
    fromcreateddate: from,
    endcreateddate: to,
    active: activeStatus,
    campaignname: "",
    ispageload: false,
    pagesize: dataLimit,
    currentpageno: count,
    withoutpagination: false,
    pagedirection: "",
  };

  // Fetch campaign data
  const fetchCampaignData = async () => {
    try {
      const DQRSearch = getUrlByOperation("DQRSearch");
      const response = await axios.post(DQRSearch, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });

      if (response.data && Array.isArray(response.data.data)) {
        const rows = response.data.data;
        setData(rows);
        setHasMore(rows.length === Number(dataLimit));
        // Calculate approximate total items
        const approximateTotal = (count * Number(dataLimit)) + rows.length + (rows.length === Number(dataLimit) ? Number(dataLimit) : 0);
        setTotalItems(approximateTotal);
      } else {
        setData([]);
        setHasMore(false);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching campaign data:", error);
      setHasMore(false);
      setTotalItems(0);
    }
  };

  // Pagination navigation functions
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setDataLimit(newItemsPerPage);
    setCount(0); // Reset to first page when changing items per page
  };

  const handlePageChange = (page) => {
    setCount(page - 1); // Convert 1-based page to 0-based index
  };

// Clipboard utility functions
function copyToClipboard(text) {
  // Try to use the Clipboard API first
  if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text)
      .then(() => true)
      .catch(err => {
        console.error('Could not copy text using Clipboard API: ', err);
        return fallbackCopyToClipboard(text);
      });
  } else {
    // Fall back to the textarea method
    return Promise.resolve(fallbackCopyToClipboard(text));
  }
}

function fallbackCopyToClipboard(text) {
  // Create a temporary textarea element
  const textArea = document.createElement('textarea');
  textArea.value = text;
  
  // Make the textarea out of viewport
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  
  // Select and copy
  textArea.focus();
  textArea.select();
  
  let success = false;
  try {
    success = document.execCommand('copy');
  } catch (err) {
    console.error('Failed to copy with fallback method:', err);
  }
  
  // Remove the textarea from DOM
  document.body.removeChild(textArea);
  return success;
}

// Then update your handlePublish function:
const handlePublish = async (id) => {
  setPublishLoading(true);
  try {
    // First, call the API to generate the publish ID
    const response = await axios.post(
      'https://api.dqr-display-tms.bonrix.in/api/DQROperation/SubUser/Generate/PublishId',
      { id },
      {
        headers: {
          'accept': 'text/plain',
          'UserId': userid || '1',
          'X-Authorization': token,
          'Content-Type': 'application/json-patch+json'
        }
      }
    );

    // Check if the API response is successful
    if (response.data && response.data.isresponse) {
      // Get the publish ID from the response
      const publishId = response.data.publishid || "";
      
      // Generate the publishable URL
      const publishUrl = `${window.location.origin}/CS80/DQRImages/${publishId}`;
      
      // Update state with the publish info
      setPublishInfo({ 
        id, 
        encodedUrl: publishUrl, 
        encodedId: publishId 
      });
      
      // Copy URL to clipboard using our enhanced function
      const copied = await copyToClipboard(publishUrl);
      
      if (copied) {
        setMessage("URL copied to clipboard!");
        setCopySuccess(true);
      } else {
        setMessage("Generated URL: " + publishUrl);
        setCopySuccess(true);
      }
      
      // Refresh the data to get the updated publishid
      fetchCampaignData();
    } else {
      // Handle API error
      throw new Error(response.data?.errormsg || "Failed to generate publish ID");
    }
  } catch (error) {
    console.error("Error generating publish ID:", error);
    setMessage(error.message || "Failed to generate publish URL");
  } finally {
    setPublishLoading(false);
  }
};

// And update your handleCopyClick function:
const handleCopyClick = async (id, publishId) => {
  const publishUrl = `${window.location.origin}/CS80/DQRImages/${publishId}`;
  
  try {
    const copied = await copyToClipboard(publishUrl);
    
    if (copied) {
      setMessage("URL copied to clipboard!");
      setCopySuccess(true);
    } else {
      setMessage("URL: " + publishUrl);
      setCopySuccess(true);
    }
  } catch (error) {
    console.error("Failed to copy URL:", error);
    setMessage("Failed to copy URL to clipboard: " + publishUrl);
  }
};

const handleCopyClick7Inch = async (id, publishId) => {
  const publishUrl = `${window.location.origin}/SMD/DQRImages/${publishId}`;
  
  try {
    const copied = await copyToClipboard(publishUrl);
    
    if (copied) {
      setMessage("URL copied to clipboard!");
      setCopySuccess(true);
    } else {
      setMessage("URL: " + publishUrl);
      setCopySuccess(true);
    }
  } catch (error) {
    console.error("Failed to copy URL:", error);
    setMessage("Failed to copy URL to clipboard: " + publishUrl);
  }
};

  // const handleCopyClick = (id, publishId) => {
  //   const publishUrl = `${window.location.origin}/CS80/DQRImages/${publishId}`;
  //   navigator.clipboard.writeText(publishUrl)
  //     .then(() => {
  //       setMessage("URL copied to clipboard!");
  //       setCopySuccess(true);
  //     })
  //     .catch(error => {
  //       console.error("Failed to copy URL:", error);
  //       setMessage("Failed to copy URL to clipboard");
  //     });
  // };



  // const handlePublish = async (id) => {
  //   setPublishLoading(true);
  //   try {
  //     // First, call the API to generate the publish ID
  //     const response = await axios.post(
  //       'https://api.dqr-display-tms.bonrix.in/api/DQROperation/Generate/PublishId',
        
  //       { id },
  //       {
  //         headers: {
  //           'accept': 'text/plain',
  //           'UserId': userid || '1',
  //           'X-Authorization': token,
  //           'Content-Type': 'application/json-patch+json'
  //         }
  //       }
  //     );

  //     // Check if the API response is successful
  //     if (response.data && response.data.isresponse) {
  //       // Get the publish ID from the response
  //       const publishId = response.data.publishid || "";
        
  //       // Generate the publishable URL
  //       const publishUrl = `${window.location.origin}/CS80/DQRImages/${publishId}`;
        
  //       // Update state with the publish info
  //       setPublishInfo({ 
  //         id, 
  //         encodedUrl: publishUrl, 
  //         encodedId: publishId 
  //       });
        
  //       // Copy URL to clipboard
  //       await navigator.clipboard.writeText(publishUrl);
  //       setMessage("URL copied to clipboard!");
  //       setCopySuccess(true);
        
  //       // Refresh the data to get the updated publishid
  //       fetchCampaignData();
  //     } else {
  //       // Handle API error
  //       throw new Error(response.data?.errormsg || "Failed to generate publish ID");
  //     }
  //   } catch (error) {
  //     console.error("Error generating publish ID:", error);
  //     setMessage(error.message || "Failed to generate publish URL");
  //   } finally {
  //     setPublishLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchCampaignData();
  }, [getUrlByOperation, from, to, activeStatus, count, dataLimit, isOn]);

  const handleAddPop = () => {
    navigate("/dqr-image-add");
  };

  const handleUpdatePop = (id) => {
    navigate(`/dqr-image-update/${id}`);
  };

  const handleShowImagePop = (id, name) => {
    navigate(`/show-dqr-images/${id}/${name}`);
  };

  const handleDelete = (e) => {
    const requestBody = { id: e.target.id };

    const DQRDelete = getUrlByOperation("DQRDelete");
    axios
      .post(DQRDelete, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      })
      .then((response) => {
        // Refetch the data after delete to refresh the list
        setMessage("Data deleted successfully!");
        fetchCampaignData(); // Call search API after delete
      })
      .catch((error) => {
        console.error("Error deleting item:", error);
        setMessage("Failed to delete data");
      });
  };

  const handleToggle = async (e, item) => {
    const DQRActive = getUrlByOperation("DQRActive");
    const DQRDeactive = getUrlByOperation("DQRDeactive");
    const apiUrl = item.active
      ? DQRDeactive
      : DQRActive;

    const requestBody = { id: item.id };

    try {
      await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      // Update the state to reflect the change
      setData(
        data.map((d) => (d.id === item.id ? { ...d, active: !item.active } : d))
      );
    } catch (error) {
      console.error("Error updating status:", error);
      if (error.message === "relogin token expire") {
        navigate("/login"); // Redirect to login page
      }
    }
  };

  // Message cleanup effect
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
        setCopySuccess(false);
      }, 3000); // Clear the message after 3 seconds
      return () => clearTimeout(timer); // Cleanup the timer
    }
  }, [message]);

  const handleUnPublish = async (id, publishId) => {
    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/DQROperation/SubUser/UnPublishId',
        { id },
        {
          headers: {
            'accept': 'text/plain',
            'UserId': userid || '1',
            'X-Authorization': token,
            'Content-Type': 'application/json-patch+json'
          }
        }
      );
      
      if (response.data && response.data.isresponse) {
        setMessage("Audio package unpublished successfully!");
        // Refresh the data to update the UI
        fetchCampaignData();
      } else {
        throw new Error(response.data?.errormsg || "Failed to unpublish audio package");
      }
    } catch (error) {
      console.error("Error unpublishing audio package:", error);
      setMessage(error.message || "Failed to unpublish audio package");
    }
  };

  
   const handleCopyHttp = (key) => {
    setMessage("URL copied to clipboard!");
    const urlToCopy = `http://api.dqr-display-tms.bonrix.in/api/Share/SubUser/DQR/${key}`;
    navigator.clipboard.writeText(urlToCopy)
      .then(() => {
        setCopied(true);
        setMessage("URL copied to clipboard!");
        setTimeout(() => setCopied(false), 2000); // hide message after 2s
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

    const handleCopyHttps = (key) => {
      setMessage("URL copied to clipboard!");
    const urlToCopy = `https://api.dqr-display-tms.bonrix.in/api/Share/SubUser/DQR/${key}`;
    navigator.clipboard.writeText(urlToCopy)
      .then(() => {
        setCopied(true);
        setMessage("URL copied to clipboard!");
        setTimeout(() => setCopied(false), 2000); // hide message after 2s
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  
    const handleCopyHttpsFristImage = (key) => {
      setMessage("URL copied to clipboard!");
    const urlToCopy = `https://api.dqr-display-tms.bonrix.in/api/Share/SubUser/DQR/FirstImage/${key}`;
    navigator.clipboard.writeText(urlToCopy)
      .then(() => {
        setCopied(true);
        setMessage("URL copied to clipboard!");
        setTimeout(() => setCopied(false), 2000); // hide message after 2s
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

 const renderPublishColumn = (item) => {
    // If the item already has a publishid, show it with a copy button
    if (item.publishid) {
      // Truncate publishid if it's longer than 5 characters
      const displayId = item.publishid.length > 5 
        ? `${item.publishid.substring(0, 5)}...` 
        : item.publishid;
        
      return (
        <div className="d-flex flex-column">
          <div className="mb-2">
            <span className="badge badge-info">{displayId}</span>
          </div>
          <div className="btn-group">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleCopyClick(item.id, item.publishid)}
              title="Copy URL"
            >
              <i className="fas fa-copy mr-1"></i> URL
            </button>
               <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleCopyClick7Inch(item.id, item.publishid)}
              title="Copy URL"
            >
              <i className="fas fa-copy mr-1"></i> URL SMD 7 Inch
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => handleCopyHttp(item.publishid)}
              title="Copy HTTP URL"
            >
              HTTP
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => handleCopyHttps(item.publishid)}
              title="Copy HTTPS URL"
            >
              HTTPS
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => handleCopyHttpsFristImage(item.publishid)}
              title="Copy HTTPS URL"
            >
              HTTPS first Image
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleUnPublish(item.id, item.publishid)}
              title="Unpublish"
            >
              <i className="fas fa-eye-slash"></i>
            </button>
          </div>
        </div>
      );
    }
    
    // Check if this item is currently being processed
    if (publishInfo.id === item.id) {
      // Truncate encodedId if it's longer than 5 characters
      const displayId = publishInfo.encodedId.length > 5 
        ? `${publishInfo.encodedId.substring(0, 5)}...` 
        : publishInfo.encodedId;
        
      return (
        <div className="d-flex flex-column">
          <div className="mb-2">
            <span className="badge badge-info">{displayId}</span>
          </div>
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => handleCopyClick(item.id, publishInfo.encodedId)}
            title="Copy URL"
          >
            <i className="fas fa-copy mr-1"></i> Copy URL
          </button>
        </div>
      );
    }
    
    // If no publishid and not currently processing, show the publish button
    return (
      <button
        className="btn btn-sm btn-success"
        onClick={() => handlePublish(item.id)}
        disabled={publishLoading}
      >
        {publishLoading ? (
          <>
            <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
            Publishing...
          </>
        ) : (
          <>
            <i className="fas fa-globe mr-1"></i> Publish
          </>
        )}
      </button>
    );
  };


  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h1 className="mb-0">DQR Images</h1>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleAddPop}
                >
                  Add DQR Images
                </button>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <hr />
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body table-responsive p-0">
                      <table className="table table-hover table-striped">
  <thead className="thead-light">
    <tr>
      <th style={{width: '5%'}} className="text-center">Id</th>
      <th style={{width: '15%'}}>Name</th>
      <th style={{width: '15%'}}>Description</th>
      <th style={{width: '15%'}} className="text-center">Show Images</th>
      <th style={{width: '20%'}} className="text-center">Action</th>
      <th style={{width: '10%'}} className="text-center">Active</th>
      <th style={{width: '20%'}} className="text-center">Publish</th>
    </tr>
  </thead>
  <tbody>
    {data.map((item, index) => (
      <tr key={index}>
        <td className="text-center">{item.id}</td>
        <td>
          <strong>{item.dqrname}</strong>
        </td>
        <td>{item.remark || "-"}</td>
        <td className="text-center">
          <button
            className="btn btn-sm btn-info"
            onClick={() => handleShowImagePop(item.id, item.dqrname)}
          >
            <i className="fas fa-images mr-1"></i> Show Images
          </button>
        </td>
        <td className="text-center">
          <div className="btn-group">
            <button
              className="btn btn-sm btn-warning mr-1"
              onClick={() => handleUpdatePop(item.id)}
            >
              <i className="fas fa-edit mr-1"></i> Update
            </button>
            <button
              className="btn btn-sm btn-danger"
              id={item.id}
              onClick={handleDelete}
            >
              <i className="fas fa-trash mr-1"></i> Delete
            </button>
          </div>
        </td>
        <td className="text-center">
          <Switch
            isOn={item.active}
            handleToggle={(e) => handleToggle(e, item)}
            id={item.id}
          />
        </td>
        <td className="text-center">
          {renderPublishColumn(item)}
        </td>
      </tr>
    ))}
  </tbody>
</table>
                    </div>
                    <Pagination
                      currentPage={count + 1}
                      totalPages={hasMore ? count + 2 : count + 1}
                      onPageChange={handlePageChange}
                      itemsPerPage={Number(dataLimit)}
                      onItemsPerPageChange={handleItemsPerPageChange}
                      totalItems={totalItems}
                      showPageNumbers={false}
                      showItemsPerPageSelector={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Added toast notification for copy success */}
      {copySuccess && (
        <div style={{ position: "fixed", top: "20px", right: "10px", width: "25%", zIndex: "9999" }}>
          <div
            className="alert alert-success d-flex align-items-center"
            role="alert"
            style={{ marginBottom: "10px" }}
          >
            <div>URL copied to clipboard!</div>
          </div>
        </div>
      )}
      {message === "URL copied to clipboard!" && <SuccessMessage message={message} />}
     
      {message === "Data deleted successfully!" && (
        <SuccessMessage message={message} />
      )}

      {message === "Failed to delete data" && (
        <FailedMessage message={message} />
      )}
    </>
  );
};

export default DqrImagesList;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}